import React, { useState } from 'react';
import { collection, addDoc } from "firebase/firestore";
import { auth, db } from "./firebaseConfig";

function ContentInput() {
  const [idea, setIdea] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (idea.trim() === '') return;

    if (!auth.currentUser) {
      alert("You must be logged in to add ideas.");
      return;
    }

    try {
      setLoading(true);
      await addDoc(collection(db, "ideas"), {
        text: idea,
        userId: auth.currentUser.uid,
        createdAt: new Date()
      });
      setIdea('');
    } catch (error) {
      alert("Error adding idea: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        backgroundColor: "#f4f3ee", // soft beige background
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          width: "100%",
          maxWidth: "500px",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#4c6042", marginBottom: "20px" }}>Add a New Idea 💡</h2>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <input
            type="text"
            placeholder="Write your content idea here..."
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
            style={{
              padding: "12px 14px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              fontSize: "15px",
              outline: "none",
              transition: "border-color 0.2s ease",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#91a58b")}
            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "12px",
              border: "none",
              borderRadius: "8px",
              backgroundColor: loading ? "#aab7a0" : "#91a58b",
              color: "white",
              fontWeight: "bold",
              fontSize: "15px",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "background-color 0.2s ease",
            }}
          >
            {loading ? "Adding..." : "Add Idea"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContentInput;
